// extracted by mini-css-extract-plugin
export var emptyState = "_66-d";
export var statCard = "_66-c";
export var table = "_66-0";
export var tableCell = "_66-4";
export var tableCellClickable = "_66-5 _66-4";
export var tableCellDefault = "_66-6 _66-4";
export var tableCellEmpty = "_66-8";
export var tableCellWithValue = "_66-7";
export var tableContainer = "_66-e";
export var tableHeaderWeight = "_66-1";
export var tableHeaderZone = "_66-2";
export var tableRowHeader = "_66-3";
export var viewModeButton = "_66-9";
export var viewModeButtonActive = "_66-a _66-9";
export var viewModeButtonInactive = "_66-b _66-9";